import {
    redirect,
    useActionData,
    useLoaderData,
    useParams,
    useRevalidator,
    useRouteLoaderData,
    useSubmit,
    useSearchParams
} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import {useForm} from "react-hook-form";
import {Autoform} from "../../../../components/forms/autoform";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Box} from "@mui/material";
import {showSnackbar} from "../../../../components/snackbarUtils";
import PageTitle from "../../../../components/PageTitle";

export async function loader({request, params}) {
    const id = params.object_id;
    return (await api.get(`/api/CreateObjForms/HotelPrice/`)).data.form;
}

export async function action({request, params}) {
    const formData = await request.formData();
    const obj_id = params.object_id;
    const children_id = formData.get("children_id");
    const rate_id = formData.get("rate_id");
    // Функция для преобразования формата даты в YYYY-MM-DD
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split(".");
        if (parts.length === 3) {
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        return dateStr; // Если формат уже верный, не меняем
    };

    // Преобразование дат перед отправкой
    const updatedFormData = new FormData();
    formData.forEach((value, key) => {
        if (key === "default_period_start" || key === "default_period_end") {
            updatedFormData.append(key, formatDate(value));
        } else {
            updatedFormData.append(key, value);
        }
    });
    try {
        const response = await api.post(`api/empty/empty/${children_id}/${rate_id}/0/`, updatedFormData);

        if (response.status === 201) {
            showSnackbar("Ціна успішно додана!", "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });

            setTimeout(() => {
                window.location.href = `/object/${obj_id}/tariffs`; // Перенаправление через 1 сек
            }, 3000);
        } else {
            showSnackbar('Помилка при додаванні ціни', 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    } catch (e) {
        showSnackbar(`Помилка при додаванні ціни ${e}`, 'error', {
            sx: {backgroundColor: "#ff0000", color: "white"}
        });
        return {error: e}
    }
    return null;
}

export default function ObjectPricesAdd() {
    const {object_id} = useParams();
    const submit = useSubmit();
    const [searchParams] = useSearchParams();
    const children_id = searchParams.get("children_id");
    const rate_id = searchParams.get("rate_id");
    const formHook = useForm();
    const revalidator = useRevalidator();
    const loaderData = useLoaderData();
    const actionData = useActionData();
    const handleSubmitForm = (data) => {
        const formData = jsonToFormData({...data, children_id: children_id, rate_id: rate_id});
        submit(formData, {
            method: 'post'
        })
    }

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/prices`}
            title={{text: 'Додати нову ціну'}}
        >
            <PageTitle title={`Нова ціна: ${rate_id || children_id || object_id || "ID"}`} />
            <Autoform
                revalidator={revalidator}
                fields={loaderData}
                formName='HotelPrice'
                formHook={formHook}
                onSubmit={handleSubmitForm}
            />
            {actionData?.response && (<Box>
                {JSON.stringify(actionData.response?.data)}
            </Box>)}
        </ModalUrlWindow>
    )
}
